"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.COUPON_ICON_DEFAULT_COLORS = void 0;
var _react = _interopRequireWildcard(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const COUPON_ICON_DEFAULT_COLORS = exports.COUPON_ICON_DEFAULT_COLORS = {
  starburstFrom: '#DDD4FF',
  starburstTo: '#F5F2FF',
  glow: '#2200B3',
  ticket: '#551EE3',
  percentCircle: '#E3DCFE',
  ring: '#FFFFFF',
  detail: '#E5F4F8',
  innerShadow: '#B7A3FF'
};
const toMatrixRgb = hex => {
  const h = String(hex).replace('#', '');
  const full = h.length === 3 ? h.split('').map(c => c + c).join('') : h;
  const channel = i => parseInt(full.slice(i * 2, i * 2 + 2), 16) / 255;
  return [channel(0), channel(1), channel(2)];
};
const CouponIcon = _ref => {
  let _ref$size = _ref.size,
    size = _ref$size === void 0 ? 58 : _ref$size,
    colorsProp = _ref.colors;
  const colors = _objectSpread(_objectSpread({}, COUPON_ICON_DEFAULT_COLORS), colorsProp);
  const innerShadowRgb = colors.innerShadow ? toMatrixRgb(colors.innerShadow) : null;
  const flatStarburst = colors.starburstFrom === colors.starburstTo;
  const uid = (0, _react.useId)().replace(/:/g, '');
  const di = "di_".concat(uid);
  const f = "f_".concat(uid);
  const grad = "grad_".concat(uid);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
    width: size,
    height: size,
    viewBox: "0 0 72.1465 72.3232",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      display: 'block'
    },
    "aria-hidden": "true",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
        filter: "url(#".concat(di, ")"),
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          d: "M52.375 54.5036C51.5459 58.062 47.9228 60.2161 44.4005 59.2448L44.4005 59.2448C42.3276 58.6732 40.1062 59.1752 38.4805 60.5826L38.4805 60.5825C35.7181 62.974 31.5209 62.587 29.2422 59.7309C27.9012 58.0501 25.809 57.1505 23.6665 57.3335L23.6665 57.3335C20.026 57.6445 16.8578 54.8645 16.6931 51.2145L16.6931 51.2144C16.5961 49.0663 15.4323 47.1088 13.5915 45.9975C10.4634 44.1093 9.53439 39.998 11.5466 36.9483L11.5465 36.9482C12.7307 35.1534 12.9398 32.8857 12.1037 30.9046L12.1036 30.9046C10.6829 27.5384 12.3479 23.6661 15.7684 22.3816C17.7813 21.6256 19.2835 19.9138 19.7715 17.8196C20.6006 14.2612 24.2237 12.1072 27.7459 13.0784L27.746 13.0784C29.8189 13.65 32.0402 13.148 33.6659 11.7407L33.666 11.7407C36.4284 9.34927 40.6255 9.73617 42.9043 12.5923C44.2453 14.2731 46.3375 15.1727 48.48 14.9897L48.48 14.9897C52.1205 14.6787 55.2887 17.4587 55.4534 21.1088L55.4534 21.1088C55.5503 23.2569 56.7142 25.2145 58.555 26.3257C61.683 28.2139 62.6121 32.3252 60.5999 35.375L60.6 35.375C59.4158 37.1698 59.2067 39.4376 60.0428 41.4186L60.0429 41.4187C61.4636 44.7849 59.7986 48.6571 56.3781 49.9416C54.3651 50.6976 52.863 52.4095 52.375 54.5036Z",
          fill: flatStarburst ? colors.starburstFrom : "url(#".concat(grad, ")")
        })
      }), colors.glow && /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
        filter: "url(#".concat(f, ")"),
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("ellipse", {
          cx: "35.1123",
          cy: "44.9461",
          rx: "13.3369",
          ry: "2.18359",
          fill: colors.glow
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
            d: "M29.2112 26.2725C28.2821 26.1186 27.3308 26.3627 26.5914 26.9457L20.8923 31.4372C19.6621 32.3753 19.3573 34.3453 20.2465 35.6016L24.1874 41.4494C24.7017 42.2122 25.5073 42.73 26.4153 42.8811L46.9561 46.2925C48.7466 46.5902 50.4438 45.3927 50.7639 43.6053L52.5638 33.5557C52.8899 31.737 51.6658 30.0021 49.8424 29.6994L29.2112 26.2725Z",
            fill: colors.ticket
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          d: "M21.6133 33.4702C21.7743 32.5274 22.6684 31.8946 23.6106 32.0555C24.5527 32.2164 25.1862 33.1101 25.0252 34.0528C24.8643 34.9949 23.97 35.6284 23.0279 35.4675C22.0858 35.3066 21.4524 34.4123 21.6133 33.4702Z",
          fill: colors.percentCircle
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          d: "M22.371 32.7777C22.9921 32.9438 23.5103 33.4779 23.8037 34.3152C24.096 35.1496 24.1414 36.2352 23.8392 37.3654C23.5369 38.4957 22.9558 39.4137 22.286 39.9908C21.6138 40.5699 20.8983 40.7741 20.2771 40.608C19.6559 40.4419 19.1378 39.9078 18.8444 39.0705C18.552 38.2361 18.5067 37.1506 18.8089 36.0203C19.1111 34.89 19.6923 33.972 20.3621 33.3949C21.0342 32.8158 21.7498 32.6116 22.371 32.7777Z",
          stroke: colors.ring
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          d: "M22.8134 31.2175C20.1503 32.6882 20.1715 34.5604 22.2123 36.6324",
          stroke: colors.ticket,
          strokeWidth: "2"
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
            d: "M34.4475 41.3932C34.348 41.3763 34.2504 41.3391 34.1605 41.2802C33.8113 41.0513 33.7139 40.5825 33.9427 40.2332L39.3612 31.9672C39.59 31.6182 40.0581 31.5202 40.4081 31.7494C40.7574 31.9783 40.8548 32.4471 40.6259 32.7964L35.2075 41.0623C35.0374 41.3217 34.735 41.4423 34.4475 41.3932Z",
            fill: colors.detail
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
            d: "M40.815 40.7835C39.5768 40.5723 38.6798 39.443 38.7814 38.1671C38.8894 36.8171 40.0751 35.8064 41.4253 35.9138C42.7723 36.0229 43.7861 37.2075 43.6786 38.5577C43.5707 39.9078 42.3849 40.9185 41.0347 40.811C40.9606 40.8051 40.8872 40.7959 40.815 40.7835ZM41.3894 37.432C41.3615 37.4273 41.3335 37.4237 41.305 37.4215C40.7862 37.3801 40.3304 37.7686 40.2891 38.2874C40.269 38.5387 40.348 38.7829 40.5116 38.9747C40.6751 39.1667 40.903 39.284 41.155 39.3034C41.6738 39.3448 42.1295 38.9564 42.171 38.4374C42.2101 37.9472 41.8653 37.5132 41.3894 37.432Z",
            fill: colors.detail
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
            d: "M33.5009 36.2794C32.2624 36.0681 31.3655 34.9388 31.467 33.6629C31.575 32.3129 32.7607 31.3022 34.1109 31.4097C35.4578 31.5206 36.4717 32.7034 36.3642 34.0535C36.2563 35.4035 35.0705 36.4143 33.7203 36.3068C33.6463 36.3007 33.5729 36.2917 33.5009 36.2794ZM34.075 32.9278C34.0471 32.923 34.0191 32.9194 33.9906 32.9173C33.4718 32.8758 33.016 33.2644 32.9747 33.7832C32.9333 34.3021 33.3227 34.7589 33.8406 34.7992C34.3594 34.8406 34.8151 34.4521 34.8566 33.9332C34.8957 33.4429 34.5509 33.009 34.075 32.9278Z",
            fill: colors.detail
          })]
        })]
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("defs", {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("filter", {
        id: di,
        x: "6.48231",
        y: "8.17132",
        width: "59.1819",
        height: "61.9806",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("feFlood", {
          floodOpacity: "0",
          result: "BackgroundImageFix"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("feOffset", {
          dy: "4"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("feGaussianBlur", {
          stdDeviation: "2"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("feComposite", {
          in2: "hardAlpha",
          operator: "out"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("feBlend", {
          mode: "normal",
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("feBlend", {
          mode: "normal",
          in: "SourceGraphic",
          in2: "effect1_dropShadow",
          result: "shape"
        }), colors.innerShadow && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("feColorMatrix", {
            in: "SourceAlpha",
            type: "matrix",
            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
            result: "hardAlpha"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("feOffset", {
            dy: "-2"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("feGaussianBlur", {
            stdDeviation: "1"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("feComposite", {
            in2: "hardAlpha",
            operator: "arithmetic",
            k2: "-1",
            k3: "1"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("feColorMatrix", {
            type: "matrix",
            values: "0 0 0 0 ".concat(innerShadowRgb[0], " 0 0 0 0 ").concat(innerShadowRgb[1], " 0 0 0 0 ").concat(innerShadowRgb[2], " 0 0 0 0.08 0")
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("feBlend", {
            mode: "normal",
            in2: "shape",
            result: "effect2_innerShadow"
          })]
        })]
      }), colors.glow && /*#__PURE__*/(0, _jsxRuntime.jsxs)("filter", {
        id: f,
        x: "4.77539",
        y: "25.7625",
        width: "60.6738",
        height: "38.3672",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("feFlood", {
          floodOpacity: "0",
          result: "BackgroundImageFix"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("feBlend", {
          mode: "normal",
          in: "SourceGraphic",
          in2: "BackgroundImageFix",
          result: "shape"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("feGaussianBlur", {
          stdDeviation: "8.5",
          result: "effect1_foregroundBlur"
        })]
      }), !flatStarburst && /*#__PURE__*/(0, _jsxRuntime.jsxs)("linearGradient", {
        id: grad,
        x1: "36.0732",
        y1: "0.914957",
        x2: "36.0732",
        y2: "62.9431",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("stop", {
          stopColor: colors.starburstFrom
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("stop", {
          offset: "0.851338",
          stopColor: colors.starburstTo
        })]
      })]
    })]
  });
};
var _default = exports.default = CouponIcon;